import React from 'react';

function Modal(props) {
    return (
        <div className='calendar-popup-wrapper'>{props.children}</div>
    );
}

export default Modal;
